import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const deleteSurveyAction = createAsyncThunk(
    'delete-survey',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/delete-survey`, { survey_id: data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const deleteSurveySlice = createSlice({
    name: 'delete-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(deleteSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(deleteSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(deleteSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const deleteSurveyReducer = deleteSurveySlice.reducer    